import React from "react";
import Image from "next/image";
import { urls } from "data/links";
import { perksOfTeacher } from "data/perks-of-teacher";
import {
  Wrapper,
  Title,
  RegisterCTA,
  TextWrapper,
  CardsWrapper,
  CardSection,
  Card,
  CardTitle,
  Toggle,
  Toggle2,
  ImgWrapper
} from "./akademi-become-teacher.styles";

export const AkademiBecomeTeacher: React.FC = () => {
  return (
    <Wrapper>
      <TextWrapper>
        <Title>Dengan menjadi Guru Juara, kamu akan mendapatkan:</Title>
        <Toggle>
          <RegisterCTA href={urls.bambooHr}>
            Tertarik? Daftar sekarang
          </RegisterCTA>
        </Toggle>
      </TextWrapper>
      <CardsWrapper>
        <CardSection>
          {perksOfTeacher.map((perk) => (
            <Card key={perk.imgAlt}>
              <ImgWrapper>
                <Image
                  src={perk.cardImg}
                  alt={perk.imgAlt}
                  width={80}
                  height={80}
                />
              </ImgWrapper>
              <CardTitle dangerouslySetInnerHTML={{ __html: perk.cardTitle }} />
            </Card>
          ))}
        </CardSection>
        <Toggle2>
          <RegisterCTA rel="nofollow" href={urls.bambooHr}>
            Tertarik? Daftar sekarang
          </RegisterCTA>
        </Toggle2>
      </CardsWrapper>
    </Wrapper>
  );
};
